var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartMultitype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chart--multitype_svg__clip0_61530_7491)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.5H21v6h1.5v-6zM19.5 13.5H18v9h1.5v-9zM16.5 19.5H15v3h1.5v-3zM6.75 12a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zm3.674 4.5H7.5v-2.924a3.761 3.761 0 012.924 2.924zM6.75 21A3.75 3.75 0 016 13.576V16.5A1.5 1.5 0 007.5 18h2.924a3.756 3.756 0 01-3.674 3zM16.901 9l3-4.5H22.5V3h-3.401l-3 4.5H13.5v-6H12v9a1.5 1.5 0 001.5 1.5h9v-1.5h-9V9h3.401zM8.25 6a.75.75 0 100-1.5.75.75 0 000 1.5zM6.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zM5.25 4.5a.75.75 0 100-1.5.75.75 0 000 1.5zM3.75 7.5a.75.75 0 100-1.5.75.75 0 000 1.5zM2.25 10.5a.75.75 0 100-1.5.75.75 0 000 1.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chart--multitype_svg__clip0_61530_7491"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgChartMultitype;